import { useState } from "react"
import MyModal from "./MyModal"
import Usages from "./Usages"
import { useAuth } from "../lib/useAuth"

const InfoModal = ({ sidebarIsOpen }) => {
    const { user } = useAuth()

    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => setIsOpen(!isOpen)
    if (!user) {
        return
    }
    return (
        <>
            <span role="button" onClick={toggleModal} className="sidebar-section__item">
                <img alt="" src="assets/icons/circle-info.svg" className="sidebar-section__icon" />
                {sidebarIsOpen ? <span className="sidebar-section__item-name"> اطلاعات </span> : null}
            </span>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="800px" height="500px">
                <div className="flex flex-col">
                    <Usages />
                    <div className="">
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>دامنه:</a>
                            <a className="float-left text-blue-400">{user && user.companyDomainName}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>ایپی:</a>
                            <a className="float-left text-blue-400">{user && user.companyIp}</a>
                        </li>
                    </div>
                </div>
            </MyModal>
        </>
    )
}

export default InfoModal
